import Button from '@mui/material/Button';

import { ErrorView } from './ErrorView.js';

export interface ErrorFallbackViewProps {
  /**
   * Called by the primary action to recover. When provided, the action navigates
   * the user away (e.g. home) and clears the boundary. When omitted, the action
   * reloads the page — used by the top-level (app shell) boundary.
   */
  onReset?: () => void;
}

export function ErrorFallbackView({ onReset }: ErrorFallbackViewProps): JSX.Element {
  return (
    <ErrorView
      action={
        onReset ? (
          <Button size="large" variant="contained" onClick={onReset}>
            Go to home
          </Button>
        ) : (
          <Button size="large" variant="contained" onClick={() => window.location.reload()}>
            Reload page
          </Button>
        )
      }
      description="An unexpected error occurred while displaying this page. Try again, and if the problem persists, contact support."
      title="Something went wrong"
    />
  );
}
